import config from "../temp/config";

const App_Constants = Object.freeze({
    SC_API_KEY : `?sc_apikey=${config.sitecoreApiKey}`,
    SC_LANGUAGE : '&sc_lang=en'
});

export default App_Constants;